import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/app/utils/cn';

export interface ButtonGroupProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  'aria-label'?: string;
}

export const ButtonGroup = ({
  children,
  className,
  'aria-label': ariaLabel = 'button group',
  ...props
}: ButtonGroupProps) => {
  return (
    <div
      role="group"
      className={cn('flex flex-wrap gap-4 md:gap-6', className)}
      aria-label={ariaLabel}
      {...props}
    >
      {children}
    </div>
  );
};
